// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale'

import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/style/app.less'
import '@/assets/style/variable.less'



import i18n from './locales/i18n'

Vue.use(ElementUI, { locale })
Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js